import { render, staticRenderFns } from "./ItemActive.vue?vue&type=template&id=0f6500b0&"
import script from "./ItemActive.vue?vue&type=script&lang=js&"
export * from "./ItemActive.vue?vue&type=script&lang=js&"
import style0 from "./ItemActive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports